import * as types from "./types";

export const SCmpUserReportInitialState = {
  //get request for all role
  SCmpUserReport: [],
  SCmpUserReportLoading: false,
  SCmpUserReportError: "",
};

export const SCmpUserReportReducer = (
  state = SCmpUserReportInitialState,
  action: any
) => {
  switch (action.type) {
    case types.GET_CMP_USER_REPORT_START:
      return {
        ...state,
        SCmpUserReportLoading: true,
      };
    case types.GET_CMP_USER_REPORT_SUCCESS:
      return {
        ...state,
        SCmpUserReport: action.SCmpUserReport,
        SCmpUserReportLoading: false,
      };
    case types.GET_CMP_USER_REPORT_FAILURE:
      return {
        ...state,
        SCmpUserReportError: action.SCmpUserReportError,
        SCmpUserReportLoading: false,
      };
    default:
      return state;
  }
};
